module.exports = __webpack_public_path__ + "img/11.445a6951.png";